package ir.site.zero1plus.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import ir.site.zero1plus.theme.*
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

sealed interface CardKind : ComponentKind

val CardStyle = CssStyle<CardKind> {
    base {
        Modifier
            .borderRadius(32.px)
            .border(
                1.px,
                LineStyle.Solid,
                if (colorMode.isDark) PrimaryDark.copyf(alpha = 0.20f) else PrimaryLight.copyf(alpha = 0.55f)
            )
            .backgroundColor(if (colorMode.isDark) SurfaceDark else SurfaceLight)
            /*.padding(topBottom = 16.px, leftRight = 24.px)
            .margin(all = 16.px)*/
            .margin(all = 20.px)
            .padding(all = 20.px)
            .maxWidth(300.px)
//            .height(250.px)
    }
    cssRule(" * ") {
        Modifier.margin(0.px)
            .textAlign(TextAlign.Justify)
    }
    cssRule("p") {
        Modifier.fontSize(14.px)
            .color(if (colorMode.isDark) TextSecondaryDark else TextSecondaryLight)
    }
}


@Composable
fun MyCard(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<CardKind>? = null,
    content: @Composable () -> Unit
) {
    val finalModifier = CardStyle.toModifier(variant).then(modifier)
    Box(
        modifier = finalModifier,
        contentAlignment = Alignment.Center
    ) {
        content()

    }
}